import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

const activitySuppliersFreeEntriesRoutes: MenuInterface[] = [
    {
        code: 'SuppliersFreeOrdersList',
        route: [
            {
                content: '$type/free-entries/suppliers/orders/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'SuppliersFreeInvoicesList',
        route: [
            {
                content: '$type/free-entries/suppliers/invoices/list',
                focus: 'empty',
            }, {primaryRoute: 'content', queryParams: {isFree: 1}}
        ],
    },
];

const activityBeneficiariesFreeEntriesRoutes: MenuInterface[] = [
    {
        code: 'BeneficiariesFreeOrdersList',
        route: [
            {
                content: '$type/free-entries/beneficiaries/orders/list',
                focus: 'empty',
            }, 'content'
        ],
    },
    {
        code: 'BeneficiariesFreeInvoicesList',
        route: [
            {
                content: '$type/free-entries/beneficiaries/invoices/list',
                focus: 'empty',
            }, {primaryRoute: 'content', queryParams: {isFree: 1}}
        ],
    },
];

export const activityFreeEntriesRoutes: MenuInterface[] = [
    {
        code: 'FreeEntriesModelsList',
        route: [
            {
                content: '$type/free-entries/models/list',
                focus: 'empty'
            }, {primaryRoute: 'content', queryParams: {closeButton: 1}}
        ]
    },
    ...activitySuppliersFreeEntriesRoutes,
    ...activityBeneficiariesFreeEntriesRoutes
];
